import React from 'react'
import BaseComponent from "../pages/base/BaseComponent";
import {Button, Col, Form, Modal, Row, Table} from "@themesberg/react-bootstrap";
import label from "enqc-utilities/src/label/Label"
import Endpoint from "enqc-utilities/src/api/Endpoint";
import PropTypes from 'prop-types';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faFilter} from "@fortawesome/free-solid-svg-icons";
import PaginationTop from "./PaginationTop";
import SearchInput from "./input/SearchInput";

export default class UserFilterModal extends BaseComponent{

    constructor(props) {
        super(props);
        this.state = {
            selectedUsers:new Set([]),
            search:"",
            users:[],
            user:{},
            sortOption:{},
            page:1,
            totalPage: 0,
            totalElement: 0,
            pageElement: 0,
            show:false
        }
    }

    componentDidMount() {
        super.componentDidMount();
    }

    addUserSelectedId(object){
        let {selectedUsers} = this.state
        selectedUsers.add(object)
        this.setState({selectedUsers})
    }

    removeUserSelectedId(object){
        let {selectedUsers} = this.state
        let objectToDelete = undefined ;
        selectedUsers.forEach((item)=>{
            if(item.id===object.id){
                objectToDelete = item
            }
        })
        if(objectToDelete){
            selectedUsers.delete(objectToDelete)
        }
        this.setState({selectedUsers})
    }

    exists(object){
        let {selectedUsers} = this.state
        let has = false ;
        selectedUsers.forEach((item)=>{
            if(item.id===object.id){
                has = true
            }
        })
        return has
    }


    componentWillReceiveProps(nextProps, nextContext) {
        if(nextProps!=this.props){
            let show = nextProps.show?nextProps.show:false
            let selectedUsers = nextProps.selectedUsers
            let prevState = this.state
            let search = this.state.search
            if(show && !prevState.show){
                search = ''
            }
            this.setState({show, selectedUsers, search},() => {
                if(show){
                    // window.history.pushState({ show: true }, '');
                    this.handlePopState = (event) =>{
                        if (show) {
                            this.props.onClose()
                            // window.history.pushState(null, ''); // re-push state to prevent deep back
                            window.history.pushState({ show: true }, '');
                        }
                    }
                    window.addEventListener('popstate', this.handlePopState);
                    this.fetchUsers()
                }else{
                    window.removeEventListener('popstate', this.handlePopState);
                }
            })
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevProps!=this.props){
            let show = this.props.show?this.props.show:false
            let selectedUsers = this.props.selectedUsers
            this.setState({show, selectedUsers},() => {
                if(show && !prevState.show){
                    this.fetchUsers(null)
                }
            })
        }
    }

    fetchUsers(){
        let {user, sortOption, search} = this.state
        this.get(Endpoint.API.USERS, {
            params :{
                ascending: sortOption.ascending,
                sortir: sortOption.sortir,
                page: this.state.page - 1,
                search:search
            }
        }, null, response=>{
            if(response.code===200){
                let users = response.data
                let totalPage = response.totalPage
                let totalElement = response.totalElement
                let pageElement = response.pageElement
                this.setState({users:users,totalPage, totalElement, pageElement})
            }else{
                this.props.history.goBack();
            }
        }, false, true)
    }

    onSelect(user){
        if(this.props.onSelect){
            this.props.onSelect(user);
        }
    }




    render() {
        let {users,show, selectedUsers, page,totalPage, totalElement, pageElement} = this.state
        return (
            <>
                {super.render()}
                <Modal as={Modal.Dialog} size="xl" centered show={show} onHide={()=>{}}>
                    <Modal.Header>
                        <Modal.Title className="h6">{label.SelectUser}</Modal.Title>
                        <Button variant="close" aria-label="Close" onClick={()=>{
                            this.props.onClose()
                        }} />
                    </Modal.Header>
                    <Modal.Body>
                        <Row>
                            <Col md={4} className="mb-3">
                                <SearchInput
                                    onEnter={(search) => {
                                        this.setState({search}, () => {
                                            this.fetchUsers()
                                        })
                                    }} onEmpty={() => {
                                    this.setState({search:""}, () => {
                                        this.fetchUsers()
                                    })
                                }}/>
                            </Col>
                            <Col md={8} className="text-right mb-3">
                                <PaginationTop
                                    onSelect={(page) => {
                                        this.setState({page}, () => {
                                            this.fetchUsers()
                                        })
                                    }}
                                    currentPage={page}
                                    pageCount={totalPage}
                                    totalElement={totalElement}
                                    showingRow={page}/>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Table responsive className="table-responsive table-sm align-items-center table-flush p-0">
                                    <thead className="thead-light">
                                    <tr>
                                        <th scope="col">#</th>
                                        <th scope="col">{label.Fullname}</th>
                                        <th scope="col">{label.Site}</th>
                                        <th scope="col">{label.Role}</th>
                                        <th scope="col" className="text-center">{label.Select}</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {users.map((item, index) => {
                                        return (
                                            <tr>
                                                <th scope="row">
                                                    {((page - 1) * pageElement) + (index+1)}
                                                </th>
                                                <th scope="row" className="text-wrap">
                                                    {item.fullname}
                                                </th>
                                                <td>{item.manufacturingSite.name}</td>
                                                <td>{item.userRole.name}</td>
                                                <td scope="col" className="text-center">
                                                    <Form.Check
                                                        size="lg"
                                                        id="checkbox1"
                                                        htmlFor="checkbox1"
                                                        checked={this.exists(item)}
                                                        onChange={event => {
                                                            if(this.exists(item)){
                                                                this.removeUserSelectedId(item)
                                                            }else{
                                                                this.addUserSelectedId(item)
                                                            }
                                                        }}
                                                        className="pl-3"
                                                        label="" />
                                                </td>
                                            </tr>
                                        )
                                    })}
                                    </tbody>
                                </Table>
                            </Col>
                        </Row>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button
                            size="sm"
                            variant="success"
                            onClick={event => {
                                let selectedUsers = new Set([])
                                this.setState({
                                    selectedUsers
                                }, () => {
                                    this.props.onSelect(selectedUsers)
                                })
                            }}>
                            {label.ResetFilter}
                        </Button>
                        <Button
                            variant="info"
                            size="sm"
                            onClick={event => {
                                this.props.onSelect(selectedUsers)
                            }}>
                            {label.ApplyFilter}
                            &nbsp;
                            {label.Selected_Count(selectedUsers.size?selectedUsers.size:0)}
                            &nbsp;
                            <FontAwesomeIcon size="sm" icon={faFilter} />
                        </Button>
                    </Modal.Footer>
                </Modal>
            </>
        );
    }

}
UserFilterModal.propTypes = {
    show:PropTypes.bool.isRequired,
    onClose:PropTypes.func.isRequired,
    onSelect:PropTypes.func.isRequired,
    selectedUsers:PropTypes.any

}
